import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-appointment-holidays',
  templateUrl: './appointment-holidays.component.html'
})
export class AppointmentHolidaysComponent implements OnInit {
  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

}
